// copied from calling-remote-app/navigation/hooks/useShowOfflineAlert
import { useMemo } from 'react';
import { getCriticalFailureReason, getStandaloneConnectionId, isTwilioDeviceUnregistered } from 'calling-cross-tab-library/appData/operators/widgetDetailsOperators';
import { useWidgetDetails } from 'worker-connection-library/hooks/useWidgetDetails';
import { CriticalFailureReasons } from 'calling-cross-tab-library/constants/CriticalFailureReasons';
import { getIsOutboundCall } from '../../utils/widgetDetailsOperators';
export const useShowOfflineAlert = () => {
  const {
    widgetDetails
  } = useWidgetDetails();
  const isOffline = isTwilioDeviceUnregistered(widgetDetails);
  const criticalFailureReason = getCriticalFailureReason(widgetDetails);
  const standaloneConnectionId = getStandaloneConnectionId(widgetDetails);
  const isOutboundCall = getIsOutboundCall(widgetDetails);
  const showOfflineAlert = useMemo(() =>
  // this is the old condition
  (criticalFailureReason === CriticalFailureReasons.FETCH_TOKEN_ERROR ||
  // new offline condition
  isOffline) && !!standaloneConnectionId && !isOutboundCall, [criticalFailureReason, isOffline, isOutboundCall, standaloneConnectionId]);
  return {
    showOfflineAlert
  };
};